'use client'
import React from 'react'
import Contact from '@/components/contactForm';
import Portfolio from "@/components/portfolioSection";
import WavePlaneCanvas from '@/components/waveComponent/wavePlaneCanvas';


export default function PortfolioPage() {

  return (
    <main>
      <WavePlaneCanvas />
      <Portfolio />
      <Contact />
    </main>
  )
}